import React from "react";

const Footer: React.FC = () => {
  return <div></div>;
};

export default Footer;
